import { setTerm } from './helpers';

export const setSuburbanBathroomType = setTerm('wc_site');
